import './video-sidebar.scss';

/**
 * version    1.0
 * class      <type> (VideoSidebar)
 * classdesc  Component that manage the page header
 */
export class VideoSidebar {
  constructor() {
    this.videoSidebar = document.querySelectorAll('.video-sidebar');
    this.panels = document.querySelectorAll('.cdp-side-panel');
    this.lastFocusedElement = null; // Variabile per salvare l'elemento che ha aperto il pannello

    this.init();
  }

  init() {
    this.initSidePanel();
    this.initPanelClose();
    this.initEsc();
    this.initCopyButtons();
  }

  // -------------------------
  // SIDE PANEL
  // -------------------------
  initSidePanel() {
    if (!this.videoSidebar.length) return;

    this.videoSidebar.forEach((singleVideoSidebar) => {
      const trigger = singleVideoSidebar.querySelector('[data-side-panel-open]');
      if (!trigger) return;

      trigger.setAttribute('aria-expanded', 'false');

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const panelId = trigger.getAttribute('data-side-panel-open');
        const panel = document.getElementById(panelId);

        if (!panel) return;

        const isOpen = panel.classList.contains('cdp-side-panel--open');
        this.closeAllPanels();

        if (!isOpen) {
          // Salvo chi ha cliccato
          this.lastFocusedElement = trigger;
          this.openPanel(panel, trigger);
        }
      });
    });
  }

  initCopyButtons() {
    const buttons = document.querySelectorAll('.cdp-card__copy-email');

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const email = btn.querySelector('span').textContent.trim();
        if (!email) return;

        navigator.clipboard.writeText(email);
      });
    });
  }

  // UTILITY: Trova tutti gli elementi cliccabili/tabbabli
  getFocusableElements(container) {
    return container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
  }

  // LOGICA FOCUS TRAP
  trapFocus(e, panel) {
    if (e.key !== 'Tab') return;

    const focusableElements = Array.from(this.getFocusableElements(panel));
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) { // Shift + Tab (indietro)
      if (document.activeElement === firstElement) {
        lastElement.focus();
        e.preventDefault();
      }
    } else { // Tab (avanti)
      // eslint-disable-next-line no-lonely-if
      if (document.activeElement === lastElement) {
        firstElement.focus();
        e.preventDefault();
      }
    }
  }

  openPanel(panel, trigger) {
    panel.classList.add('cdp-side-panel--open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('inert');

    // Focus sul primo elemento del pannello (o sul pannello stesso se ha tabindex)
    const focusableElements = this.getFocusableElements(panel);
    if (focusableElements.length > 0) {
      setTimeout(() => focusableElements[0].focus(), 100);
    }

    // Aggiungo il listener per la trappola del focus
    this.handleFocusTrap = (e) => this.trapFocus(e, panel);
    document.addEventListener('keydown', this.handleFocusTrap);
  }

  closePanel(panel) {
    panel.classList.remove('cdp-side-panel--open');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');

    const trigger = document.querySelector(`[data-side-panel-open="${panel.id}"]`);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    // RIMUOVO la trappola del focus
    document.removeEventListener('keydown', this.handleFocusTrap);

    // RIPRISTINO il focus sulla card originale
    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus();
    }
  }

  closeAllPanels() {
    this.panels.forEach((panel) => this.closePanel(panel));
  }

  // -------------------------
  // CLOSE HANDLERS
  // -------------------------
  initPanelClose() {
    if (!this.panels.length) return;

    this.panels.forEach((panel) => {
      panel.querySelectorAll('[data-side-panel-close]').forEach((el) => {
        el.addEventListener('click', () => {
          this.closePanel(panel);
        });
      });
    });
  }

  initEsc() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllPanels();
      }
    });
  }
}
